import { gql } from '__generated__';

export default gql(`
  mutation ResellRegistration($input: ResellRegistrationInput!) {
    resellRegistration(input: $input) {
      status
      redirect_url
    }
  }
`);
